import manifest from "./manifest.js";

const aliases = {
  [manifest.SABLIER_LOCKUP]: "LK3",
};

export default aliases;
